import React from "react";
import ReactDOM from "react-dom/client";
import { StudioApp } from "./StudioApp";
import "./styles/tokens.css";
import "./styles/global.css";
import "./styles/quiz.css";
import "./styles/letter.css";
import "./styles/chat.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <StudioApp />
  </React.StrictMode>,
);
